export const LAST_AUTH_STORAGE_KEY = 'twine_last_auth';

export const LAST_AUTH_METHODS = {
  GOOGLE: 'google',
  PASSWORD: 'password',
  CODE: 'code',
};

/**
 * Read the last-used auth method hint from localStorage.
 * Email is intentionally not persisted (privacy).
 * @returns {{ method?: string, at?: number } | null}
 */
export function getLastAuth() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }

    const raw = window.localStorage.getItem(LAST_AUTH_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    const method =
      typeof parsed.method === 'string' ? parsed.method : undefined;
    const at = typeof parsed.at === 'number' ? parsed.at : undefined;

    // Drop any legacy email field from storage on read.
    if (Object.prototype.hasOwnProperty.call(parsed, 'email')) {
      if (method) {
        window.localStorage.setItem(
          LAST_AUTH_STORAGE_KEY,
          JSON.stringify({ method, at: at || Date.now() })
        );
      } else {
        window.localStorage.removeItem(LAST_AUTH_STORAGE_KEY);
        return null;
      }
    }

    if (!method) {
      return null;
    }

    return { method, at };
  } catch (e) {
    return null;
  }
}

/**
 * Persist last-used sign-in method only (no email).
 * @param {{ method?: string }} next
 */
export function setLastAuth(next = {}) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }

    const current = getLastAuth() || {};
    const method = next.method || current.method;

    if (!method) {
      return;
    }

    window.localStorage.setItem(
      LAST_AUTH_STORAGE_KEY,
      JSON.stringify({
        method,
        at: Date.now(),
      })
    );
  } catch (e) {
    // Ignore quota / private mode failures
  }
}
